import "./App.css";
import Web3 from "web3";
import Unity, { UnityContext } from "react-unity-webgl";
import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert2";

import { ContractFuncWrapper } from "./WrappedContractFunc";
// import VConsole from "vconsole";

import RequestLoginTypeHandler from "./unity/RequestLoginTypeHandler";
import SendWalletLoginType from "./unity/SendWalletLoginType";
import RequestBitkubAuthenticationInfoHandler from "./unity/RequestBitkubAuthenticationInfoHandler";
import { useHistory } from "react-router-dom";
import { UnityEvent, UnityGameObject, UnityMethod } from "./model/UnityConstant";
import { Loading, ErrorPage, StartGame } from "./component/common/components";
import NavigateToLoginHandler from "./unity/NavigateToLoginHandler";
import useCheckAuthentication from "./hook/useCheckAuthentication";
import { getChainSetting, getNumericChainId } from "./model/NetworksDetail";
import StorageKey from "./model/StorageKey";
import LoginType, { isValidLoginType } from "./model/LoginType";
import {
    getMetaMaskProvider,
    getInjectedKubWalletProvider,
    requestAccounts,
    ensureChain,
    getChainId,
    getBalance,
} from "./utility/walletProvider";
import { getWalletConnectProvider, disconnectWalletConnect } from "./utility/kubWallet";
import { clearApplicationAuthStorage } from "./component/login/LoginScreen";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import queryString from "query-string";

import {
    getMachineFingerprint,
    generateScreenUID,
} from "./ClientIdentifier";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDEOkyD57h5vDRYsrDD28HIxAwdVUcEqYg",
    authDomain: "morningmoonvillage-cbt.firebaseapp.com",
    projectId: "morningmoonvillage-cbt",
    storageBucket: "morningmoonvillage-cbt.appspot.com",
    messagingSenderId: "290178115954",
    appId: "1:290178115954:web:f48de2a4f0117782a895eb",
    measurementId: "G-GYVMW8PV92"
};

const annoucementImg = process.env.PUBLIC_URL + '/assets/images/game/announcement.png';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const config = {
    allowFullscreen: true,
    backendURL: process.env.REACT_APP_MMV_BACKED_API_URL,
};

const fullscreenStyle = {
    height: "100%",
    width: "100%",
};

let web3Instance = null;

const unityCDN = process.env.REACT_APP_UNITY_CDN || "https://cdn.morningmoonvillage.com/unitybuild/v.0.6.4.1"
const buildId = process.env.REACT_APP_BUILD_ID || Date.now()
const unityContext = new UnityContext({
    companyName: "X10 vs BBT",
    productName: 'morning-moon',
    productVersion: buildId,
    loaderUrl: `${unityCDN}/web.loader.js?t=${buildId}`,
    dataUrl: `${unityCDN}/web.data?t=${buildId}`,
    frameworkUrl: `${unityCDN}/web.framework.js?t=${buildId}`,
    codeUrl: `${unityCDN}/web.wasm?t=${buildId}`,
});

let limuContract = null;
// create vconsole instance...
// new VConsole();


/**
 * 
 * @param {()=>{}} onContinue 
 */
function handleShowAnnouncement(onContinue) {
    swal.fire({
        imageUrl: `${annoucementImg}`,
        width: 1000,
        imageWidth: 1000,
        imageHeight: 500,
        background: "transparent",
        showConfirmButton: true,
        showCancelButton: false,
        showDenyButton: true,
        customClass: {
            confirmButton: "announcement-confirm",
            denyButton: "announcement-confirm",
        },
        denyButtonText: "Manual",
    }).then((r) => {
        console.log(">>>>>>>>>>>>>>>> r:", r);
        if (r.isConfirmed || r.isDismissed) {
            if (onContinue) onContinue();
        } else {
            window.open("https://whitepaper.morningmoonvillage.com/manual/early-access");
            handleShowAnnouncement(onContinue);
        }
    });
}
const machineFingerprint = getMachineFingerprint();
const screenUID = generateScreenUID();

function App(props) {
    const history = useHistory();
    const [isLoaded, setIsLoaded] = useState(false);
    const [progress, setProgress] = useState(0);
    const [forceNoShadow, setForceNoShadow] = useState(false);
    const isAuthenticated = useCheckAuthentication();
    const [isShowAnnouncement, setIsShowAnnouncement] = useState(true);
    const forceNoShadowRef = useRef(forceNoShadow);
    forceNoShadowRef.current = forceNoShadow;
    const [isLoadCaptcha, setIsLoadCaptcha] = useState(false);

    const [didError, setDidError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const analytics = getAnalytics();

    useEffect(() => {
        if (isAuthenticated && analytics) {
            logEvent(analytics, 'unity_load_start');
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (window.grecaptcha && window.grecaptcha.ready) {
            window.grecaptcha.ready(() => {
                console.debug("recaptcha v2 is ready");
            });
        }

        handleShowAnnouncement(() => {
            setIsShowAnnouncement(false);
        });
    }, []);

    const search = (props && props.location && props.location.search) || "";
    useEffect(() => {
        const parsedQs = queryString.parse(search);
        if (parsedQs["forceNoShadow"]) {
            const v = parsedQs["forceNoShadow"];
            setForceNoShadow(v.toLowerCase() === "true");
        }
    }, [search]);

    useEffect(() => {
        // do not execute while announcement still show
        console.log(`isShowAnnouncement => ${isShowAnnouncement}`)
        if (isShowAnnouncement) return;

        unityContext.on("error", function (message) {
            console.error("error: ", message)
            setDidError(true)
            setErrorMessage(message)

            // log event - login with metamask
            if (analytics) {
                logEvent(analytics, 'unity_load_error', { error: message });
            }
        });

        unityContext.on("loaded", function () {
            setIsLoaded(true)
            if (analytics) {
                logEvent(analytics, 'unity_load_success');
            }
        });

        unityContext.on("progress", function (p) {
            setProgress(p);
        });

        RequestLoginTypeHandler(unityContext, unityCDN === "https://cdn.morningmoonvillage.com/unitybuild/v.0.6.4.1");
        const cleanupBitkub = RequestBitkubAuthenticationInfoHandler(unityContext, history);
        const cleanupNavigation = NavigateToLoginHandler(unityContext, handleLogout);
        return () => {
            unityContext.removeEventListener("error");
            unityContext.removeEventListener("loaded");
            unityContext.removeEventListener("progress");
            unityContext.removeEventListener(UnityEvent.RequestLoginType);
            cleanupBitkub();
            cleanupNavigation();
        };
    }, [isShowAnnouncement]);

    useEffect(() => {
        const cleanupPluginFunctions = registerPluginFunctions({
            getForceNoShadowFunc: () => forceNoShadowRef.current,
        });
        return () => {
            cleanupPluginFunctions();
            removeActiveProviderListeners();
            activeLoginType = null;
        };
    }, [])


    if (!isAuthenticated) {
        return (<Loading isLoaded={false} />)
    }

    // if (didError) {
    //     return (
    //         <div>
    //             <ErrorPage isLoaded={isLoaded} errorMessage={errorMessage} />
    //         </div>
    //     )
    // }

    return (
        <div>
            <Loading isLoaded={isLoaded} progress={progress} />
            <div className="unity-container" style={{ display: isLoaded ? "block" : "none" }}>
                {!isShowAnnouncement ? <Unity
                    unityContext={unityContext}
                    style={config.allowFullscreen ? fullscreenStyle : null}
                /> : null}
            </div>
        </div>
    );

    // return didError === true ? (
    //     <div>
    //         <ErrorPage isLoaded={isLoaded} errorMessage={errorMessage} />
    //     </div>
    // ) : (
    //     <div>
    //         <Loading isLoaded={isLoaded} progress={progress} />
    //         <div className="unity-container" style={{ display: isLoaded ? "block" : "none" }}>
    //             <Unity
    //                 unityContext={unityContext}
    //                 style={config.allowFullscreen ? fullscreenStyle : null}
    //             />
    //         </div>
    //     </div>
    // );
}

const FullscreenButton = (props) => (
    <div id={props.id}>
        <input
            type="button"
            onClick={async () => {
                console.log("go to fullscreen mode...");
                unityContext.setFullscreen(true);
            }}
            value={props.title}
        ></input>
    </div>
);

function registerPluginFunctions(dependencies) {
    let wrapperFunc = null;
    const logTag = "[registerPluginFunctions]";
    const networkAddress = process.env.REACT_APP_RPC_URL;
    const provider = new Web3.providers.HttpProvider(networkAddress);
    web3Instance = new Web3(provider);

    unityContext.on(UnityEvent.ReadWebClipboardAsync, async (
        callID,
        callbackObjectName,
        callbackMethodName,
    ) => {
        let clipboardText = "";
        try {
            if (navigator?.clipboard && typeof navigator.clipboard.readText === "function") {
                clipboardText = await navigator.clipboard.readText();
            }
        } catch (error) {
            console.warn("[ReadWebClipboardAsync] Failed to read clipboard:", error);
        }
        unityContext.send(
            callbackObjectName,
            callbackMethodName,
            JSON.stringify({ callID, text: clipboardText }),
        );
    });

    console.dir(`${logTag} web3Instance => ${web3Instance}`);


    unityContext.on("JSPluginWrapper_Init", async (callID, args) => {
        // This event comes from Unity after its first-scene components initialize.
        SendWalletLoginType(unityContext);
        const logTag = "[JSPluginWrapper_Init]";
        console.log(`${logTag} called with callID: ${callID} `);
        console.log(`${logTag} args => `, args);

        const {
            gameObjectName,
            callbackEntryPointMethod,
            reportTxEventMethod,
        } = JSON.parse(args);

        console.log(`${logTag} unityCB_GameObjectName: ${gameObjectName} `);
        console.log(
            `${logTag} unityCB_CallbackEntryPointMethodName: ${callbackEntryPointMethod} `
        );
        console.log(
            `${logTag} unityCB_ReportTxEventMethodName: ${reportTxEventMethod} `
        );

        // init wrapperFunc instance
        wrapperFunc = new ContractFuncWrapper(
            () => web3Instance,
            unityContext,
            gameObjectName,
            callbackEntryPointMethod,
            reportTxEventMethod,
            process.env.REACT_APP_MMV_MULTICALL_ADDRESS,
            () => activeLoginType,
        );
        console.log(`${logTag} wrapperFunc instance created...`, wrapperFunc);
        console.log(`${logTag} multicall address:`, process.env.REACT_APP_MMV_MULTICALL_ADDRESS);
    });

    unityContext.on("JSPluginWrapper_ConnectWallet", async (callID) => {
        const logTag = "[JSPluginWrapper_ConnectWallet]";
        await connectWallet(wrapperFunc, callID);
    });

    unityContext.on("JSPluginWrapper_GetLumiBalance", async (callID) => {
        const logTag = "[JSPluginWrapper_GetLumiBalance]";
        const balance = await getLumiBalance();
        wrapperFunc.unitySend(callID, { balance }, null);
    });

    unityContext.on("JSPluginWrapper_GetBackendAPIURL", async (callID) => {
        const logTag = "[JSPluginWrapper_GetBackendAPIURL]";
        wrapperFunc.unitySend(callID, { url: config.backendURL }, null);
    });

    unityContext.on("JSPluginWrapper_CallContractFunction", async (callID, funcName, args) => {
        const logTag = "[JSPluginWrapper_CallContractFunction]";
        console.log(`${logTag} called with callID: ${callID} funcName: ${funcName} `);
        wrapperFunc.executeContractFunction(callID, funcName, args);

        try {
            const analytics = getAnalytics();
            logEvent(analytics, 'rpc_call_v1', { name: funcName });
        } catch (err) { }
    });

    unityContext.on(UnityEvent.RequestClientIdentity, async () => {
        const logTag = "[RequestClientIdentity]";
        const resp = {
            "mfp": machineFingerprint,
            "scuid": screenUID,
        };
        unityContext.send(
            UnityGameObject.WebContainerListener,
            UnityMethod.RequestClientIdentityCallback,
            JSON.stringify(resp));
    })

    unityContext.on(UnityEvent.RequestTier1Captcha, async () => {
        const logTag = "[RequestTier1Captcha]";
        let token = "";
        try {
            token = await window.grecaptcha.execute(
                process.env.REACT_APP_MMV_RECAPTCHA_SITE_KEY,
                { action: 'submit' },
            );
            console.log(logTag, "get tier1 captcha token:", token);
        } catch (err) {
            console.log(`${logTag} failed to get recaptcha v3 token: ${err}`);
            token = "";
        }

        unityContext.send(
            UnityGameObject.WebContainerListener,
            UnityMethod.RequestTier1CaptchaCallback,
            JSON.stringify({
                "captchaToken": token,
                "type": "tier1",
            }));
    });

    unityContext.on(UnityEvent.RequestTier2Captcha, async () => {
        const logTag = "[RequestTier2Captcha]";
        showTier2Captcha((resp) => {
            // resp is hcaptcha returned token...
            unityContext.send(
                UnityGameObject.WebContainerListener,
                UnityMethod.RequestTier2CaptchaCallback,
                JSON.stringify({
                    "captchaToken": resp,
                    "type": "tier2",
                }));
        });
    })

    unityContext.on(UnityEvent.CheckIfSetForceNoShadow, async () => {
        const logTag = "[CheckIfSetForceNoShadow]";
        let forceNoShadow = false;
        if (dependencies.getForceNoShadowFunc) {
            forceNoShadow = dependencies.getForceNoShadowFunc();
        }
        unityContext.send(
            UnityGameObject.WebContainerListener,
            UnityMethod.CheckIfSetForceNoShadowCallback,
            JSON.stringify({
                "forceNoShadow": forceNoShadow,
            }));
    })

    return () => {
        wrapperFunc?.executor.stopBatchingInterval();
        [
            "JSPluginWrapper_Init",
            "JSPluginWrapper_ConnectWallet",
            "JSPluginWrapper_GetLumiBalance",
            "JSPluginWrapper_GetBackendAPIURL",
            "JSPluginWrapper_CallContractFunction",
            UnityEvent.RequestClientIdentity,
            UnityEvent.RequestTier1Captcha,
            UnityEvent.RequestTier2Captcha,
            UnityEvent.CheckIfSetForceNoShadow,
            UnityEvent.ReadWebClipboardAsync,
        ].forEach((event) => unityContext.removeEventListener(event));
    };

}
async function showTier2Captcha(successCallback = null) {
    swal.fire({
        title: 'Verification Process',
        html: '<div id="captcha-wildmap" class="h-captcha"></div>',
        backdrop: false,
        showConfirmButton: false,
        showCancelButton: false,
        showDenyButton: false,
        didOpen: () => {
            console.log("sitekey:", process.env.REACT_APP_HCAPTCHA_SITE_KEY);
            window.hcaptcha.render('captcha-wildmap', {
                sitekey: process.env.REACT_APP_HCAPTCHA_SITE_KEY,
                theme: 'light',
                'error-callback': (err) => { console.error(`hcaptcha error: ${err}`) },
                'callback': (resp) => {
                    if (resp.length === 0) {
                        return;
                    }
                    console.log(resp);
                    if (successCallback) {
                        successCallback(resp);
                    }
                    swal.close();
                },
            });
        },
    });
}

async function getLumiBalance() {
    const LOG_TAG = "[getLumiBalance]";
    if (!limuContract) {
        swal.fire({
            title: "Error",
            text: "contract does not initialize",
        });
        return;
    }

    const balance = await limuContract.methods
        .balanceOf(web3Instance.eth.defaultAccount)
        .call();
    return balance;
}

let activeProvider = null;
let activeLoginType = null;
let activeProviderListeners = null;

function removeActiveProviderListeners() {
    if (activeProvider && activeProviderListeners) {
        if (typeof activeProvider.removeListener === "function") {
            activeProvider.removeListener("accountsChanged", activeProviderListeners.onAccountsChanged);
            activeProvider.removeListener("chainChanged", activeProviderListeners.onChainChanged);
            activeProvider.removeListener("disconnect", activeProviderListeners.onDisconnect);
        }
        activeProvider = null;
        activeProviderListeners = null;
    }
}

function showZeroKubBalanceNotice() {
    swal.fire({
        title: 'You have 0 KUB.',
        html: `You will need KUB coin in order to complete any transactions in Morning Moon Village.<br><br>
        You can buy KUB from Gate.io, CoinEx, Mexc or Bitkub exchange.<br>(1 KUB is enough to play several weeks.)
        <br> <br><div style="max-width:300px; margin: auto;">
        <img src="/assets/images/game/exchange-removebg-preview.png" width='100%' alt="Exchange list"/> </div>`,
        imageUrl: "/assets/images/game/kub_crop.jpeg",
        width: 800,
        imageWidth: 260,
        imageAlt: 'Custom image',
        background: "rgb(229 229 229)",
        showConfirmButton: true,
        showCancelButton: false,
        showDenyButton: true,
        customClass: {
            confirmButton: "popup-kub",
            denyButton: "popup-kub",
        },
        denyButtonText: "Buy KUB",
    }).then((r) => {
        if (r && (r.isDenied || (!r.isConfirmed && !r.isDismissed))) {
            window.open("https://whitepaper.morningmoonvillage.com/manual/how-to-convert-and-transfer-token/kub2");
        }
    });
}

async function handleLogout() {
    activeLoginType = null;
    removeActiveProviderListeners();
    try {
        await disconnectWalletConnect();
    } catch (e) {
        console.warn("[handleLogout] disconnect error:", e);
    }
    clearApplicationAuthStorage();
    if (typeof window !== "undefined") {
        window.location.replace("/login");
    }
}

function setupActiveProviderListeners(provider, chainDetail) {
    removeActiveProviderListeners();

    activeProvider = provider;
    const targetChainId = getNumericChainId(chainDetail);

    const onAccountsChanged = (accounts) => {
        console.log("[provider] accountsChanged:", accounts);
        if (!accounts || accounts.length === 0) {
            handleLogout();
        } else {
            if (web3Instance && web3Instance.eth) {
                web3Instance.eth.defaultAccount = accounts[0];
            }
            window.location.reload();
        }
    };

    const onChainChanged = (chainId) => {
        const newChainId = typeof chainId === "string" ? parseInt(chainId, 16) : Number(chainId);
        const isPass = newChainId === targetChainId;
        console.log(`[provider] chainChanged to ${chainId} (${newChainId}), isPass: ${isPass}`);
        unityContext.send(UnityGameObject.WebContainerListener, UnityMethod.OnReceiveChainChanged, isPass ? 1 : 0);
        if (!isPass) {
            ensureChain(provider, chainDetail).catch((err) => {
                console.warn("[provider] Re-switch chain failed:", err);
            });
        }
    };

    const onDisconnect = (error) => {
        console.log("[provider] disconnect:", error);
        handleLogout();
    };

    activeProviderListeners = {
        onAccountsChanged,
        onChainChanged,
        onDisconnect,
    };

    if (typeof provider.on === "function") {
        provider.on("accountsChanged", onAccountsChanged);
        provider.on("chainChanged", onChainChanged);
        provider.on("disconnect", onDisconnect);
    }
}

async function connectWallet(wrapperFunc, callID) {
    const logTag = "[connectWallet]";

    try {
        const savedLoginType = localStorage.getItem(StorageKey.LONGIN_TYPE);
        if (!isValidLoginType(savedLoginType)) {
            console.error(`${logTag} Unsupported or missing login type: ${savedLoginType}`);
            wrapperFunc.unitySend(callID, null, { code: 400, message: `Unsupported login type: ${savedLoginType}` });
            return;
        }

        const chainDetail = getChainSetting();
        let provider = null;

        if (savedLoginType === LoginType.METAMASK) {
            provider = await getMetaMaskProvider();
            if (!provider) {
                console.log(`${logTag} MetaMask is not installed!`);
                wrapperFunc.unitySend(callID, null, { code: 101, message: "MetaMask is not installed" });
                swal.fire({
                    title: "Error",
                    text: "MetaMask is not installed!",
                }).then(() => {
                    unityContext.dispatchEventListener(UnityEvent.NavigateToLogin);
                });
                return;
            }
        } else if (savedLoginType === LoginType.KUB_WALLET) {
            // Check EIP-6963 injected KUB Wallet first
            provider = await getInjectedKubWalletProvider();
            if (!provider) {
                console.log(`${logTag} KUB Wallet injected provider not found, using WalletConnect v2`);
                try {
                    provider = await getWalletConnectProvider(chainDetail);
                } catch (wcErr) {
                    console.error(`${logTag} WalletConnect failed:`, wcErr);
                    const isUserRejection = wcErr && (wcErr.code === 4001 || /rejected/i.test(wcErr.message || ""));
                    const errPayload = {
                        code: isUserRejection ? 4001 : 102,
                        message: wcErr.message || "Failed to connect to KUB Wallet",
                    };
                    wrapperFunc.unitySend(callID, null, errPayload);
                    swal.fire({
                        title: "Wallet Connection Failed",
                        text: wcErr.message || "Could not connect to KUB Wallet",
                    });
                    return;
                }
            }
        } else {
            wrapperFunc.unitySend(callID, null, { code: 400, message: `Unhandled login type: ${savedLoginType}` });
            return;
        }

        // Request accounts
        let accounts;
        try {
            accounts = await requestAccounts(provider);
        } catch (accErr) {
            console.error(`${logTag} requestAccounts failed:`, accErr);
            const isUserRejection = accErr && (accErr.code === 4001 || /rejected/i.test(accErr.message || ""));
            wrapperFunc.unitySend(callID, null, {
                code: isUserRejection ? 4001 : 103,
                message: accErr.message || "Failed to get accounts",
            });
            return;
        }

        if (!accounts || accounts.length === 0) {
            wrapperFunc.unitySend(callID, null, { code: 103, message: "No account returned from wallet" });
            await swal.fire({
                title: "Transaction Failed 000x1",
                text: "Sorry, the transaction cannot be performed at this time. Please try again",
            });
            return;
        }

        // Ensure configured KUB chain
        try {
            await ensureChain(provider, chainDetail);
        } catch (chainErr) {
            console.error(`${logTag} ensureChain failed:`, chainErr);
            const isUserRejection = chainErr && (chainErr.code === 4001 || /rejected/i.test(chainErr.message || ""));
            wrapperFunc.unitySend(callID, null, {
                code: isUserRejection ? 4001 : 104,
                message: chainErr.message || "Network switch failed",
            });
            return;
        }

        // Verify chain ID
        const currentChainId = await getChainId(provider);
        const expectedChainId = getNumericChainId(chainDetail);
        if (currentChainId !== expectedChainId) {
            console.error(`${logTag} Chain mismatch: expected ${expectedChainId}, got ${currentChainId}`);
            wrapperFunc.unitySend(callID, null, {
                code: 105,
                message: `Chain mismatch: expected ${expectedChainId}, got ${currentChainId}`,
            });
            return;
        }

        // Set up web3 instance
        web3Instance = new Web3(provider);
        web3Instance.eth.defaultAccount = accounts[0];

        // Register active listeners
        setupActiveProviderListeners(provider, chainDetail);

        // Notify Unity as soon as the approved account and chain are ready.
        activeLoginType = savedLoginType;
        SendWalletLoginType(unityContext, activeLoginType);
        console.log(`${logTag} Wallet connected successfully for account: ${accounts[0]}`);
        wrapperFunc.unitySend(callID, null, null);

        // Balance guidance is optional and must not hold up Unity's callback.
        getBalance(provider, accounts[0])
            .then((coinBalance) => {
                if (coinBalance === 0) showZeroKubBalanceNotice();
            })
            .catch((balErr) => {
                console.warn(`${logTag} Failed to check KUB balance:`, balErr);
            });
    } catch (e) {
        console.error(`${logTag} Connection error:`, e);
        wrapperFunc.unitySend(callID, null, {
            code: e && e.code === 4001 ? 4001 : 100,
            message: (e && e.message) || "Unknown wallet connection error",
        });
    }
}

export default App;
